import { Component, Injectable } from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class ImagesService {
    /**
     * @param Observable<number>
     */
    private progress$: Observable<any>;

    /**
     * @type {number}
     */
    private progress: number = 0;

    private progressObserver: any;

    private _fileUrl = '/elementData/photos';
    private _fileUrlEncoded = '/elementData/photosEncoded';
    private _fileUrlEncodedMain = '/elementData/photosEncodedMain';
    private _fileUrlMain = '/elementData/photoMain';
    private _fileUrlPrice = '/elementData/price';
    private serverURL: string;

    constructor(private http: Http) {
        this.progress$ = new Observable((observer: any) => {
            this.progressObserver = observer
        });
        this.serverURL = json.api_url;
    }

    public getImages(idElement: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._fileUrl + "/" + idElement, options)
            .toPromise()
            .then(res => { console.log(JSON.parse(res.text()).row); return JSON.parse(res.text()).row; });

    }

    public editPrice(id: number, price: string) {
        console.log(id, price);
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        return this.http.put(this.serverURL + this._fileUrlPrice + "/" + id, this.serializeObj({'price': price}), {
            headers: authHeader
        })
            .subscribe(res => { console.log(res); });
    }

    public getImageMain(idElement: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        console.log(this._fileUrlMain + "/" + idElement);
            let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + this._fileUrlMain + "/" + idElement, options)
            .toPromise()
            .then(res => { console.log(JSON.parse(res.text()).row); return JSON.parse(res.text()).row[0]; });

    }

    public deleteImage(idImage: number) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.delete(this.serverURL + this._fileUrl + "/" + idImage, options);
    }

    /**
     * @returns {Observable<number>}
     */
    public getObserver(): Observable<number> {
        return this.progress$;
    }

    /**
     * Upload files through XMLHttpRequest
     *
     * @param files
     * @returns {Promise<T>}
     */
    public upload(file: File): Promise<any> {
        return new Promise((resolve, reject) => {
            var token = localStorage.getItem('token');

            let formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open("POST",this.serverURL + this._fileUrl, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            formData.append("file", file);


            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            ImagesService.setUploadUpdateInterval(500);

            xhr.upload.onprogress = (event) => {
                this.progress = Math.round(event.loaded / event.total * 100);
                this.progressObserver.next(this.progress);
            };

            xhr.send(formData);
        });
    }

    public uploadMain(file: File): Promise<any> {
        return new Promise((resolve, reject) => {
            var token = localStorage.getItem('token');

            let formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open("POST", this.serverURL + this._fileUrlMain, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            formData.append("files[0]", file);


            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            ImagesService.setUploadUpdateInterval(500);

            xhr.upload.onprogress = (event) => {
                this.progress = Math.round(event.loaded / event.total * 100);
                this.progressObserver.next(this.progress);
            };

            xhr.send(formData);
        });
    }

    public uploadEncodedMain(file: any): Promise<any> {
        return new Promise((resolve, reject) => {
            var token = localStorage.getItem('token');

            let formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open("POST", this.serverURL + this._fileUrlEncodedMain, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            formData.append("image", file.image);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            ImagesService.setUploadUpdateInterval(500);

            xhr.upload.onprogress = (event) => {
                this.progress = Math.round(event.loaded / event.total * 100);
                this.progressObserver.next(this.progress);
                console.log(this.progress);
            };

            xhr.send(formData);
        });
    }

    public uploadEncoded(file: any, price: number): Promise<any> {
        return new Promise((resolve, reject) => {
            var token = localStorage.getItem('token');

            let formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open("POST", this.serverURL + this._fileUrlEncoded, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            formData.append("price", price);
            formData.append("image", file.image);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            ImagesService.setUploadUpdateInterval(500);

            xhr.upload.onprogress = (event) => {
                this.progress = Math.round(event.loaded / event.total * 100);
                this.progressObserver.next(this.progress);
                console.log(this.progress);
            };

            xhr.send(formData);
        });
    }

     private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }

    /**
     * Set interval for frequency with which Observable inside Promise will share data with subscribers.
     *
     * @param interval
     */
    private static setUploadUpdateInterval(interval: number): void {
        setInterval(() => { }, interval);
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/dashboard/images.service.ts
 **/